import React from 'react';
import { Card, Stack, Text, Group, Badge, Divider } from '@mantine/core';
import { IconBriefcase } from '@tabler/icons-react';
import type { CoursePlanJobFamily } from '../../../../types/lcms/coursePlan';

interface PlanJobFamiliesSectionProps {
  jobFamilies: CoursePlanJobFamily[];
}

const PlanJobFamiliesSection: React.FC<PlanJobFamiliesSectionProps> = ({ jobFamilies }) => {
  if (!jobFamilies || jobFamilies.length === 0) {
    return (
      <Card>
        <Group gap={12} mb={16}>
          <IconBriefcase size={20} />
          <Text fw={600} size='lg'>
            Job Families
          </Text>
        </Group>
        <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
          No job families assigned to this course plan
        </Text>
      </Card>
    );
  }

  return (
    <Card>
      <Group gap={12} mb={16}>
        <IconBriefcase size={20} />
        <Text fw={600} size='lg'>
          Job Families ({jobFamilies.length})
        </Text>
      </Group>

      <Stack gap={12}>
        {jobFamilies.map((item, index) => (
          <React.Fragment key={item.trLCMSPlanningJobFamiliesID}>
            <Group justify='space-between' align='flex-start'>
              <Stack gap={4} flex={1}>
                <Text fw={500} size='sm'>
                  {item.jobFamilyName}
                </Text>
                <Text size='xs' c='dimmed'>
                  Group: {item.jobFamilyGroupName}
                </Text>
                <Group gap={8}>
                  <Badge variant='light' size='xs' color='green'>
                    Family ID: {item.jobFamilyID}
                  </Badge>
                  <Badge variant='light' size='xs' color='blue'>
                    Group ID: {item.jobFamilyGroupID}
                  </Badge>
                </Group>
              </Stack>
            </Group>
            {index < jobFamilies.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </Card>
  );
};

export default PlanJobFamiliesSection;
